/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2020-07-31 17:25:14
 */
/**
 * 获取sessionStorage
 * @param {String} key 
 */
const getSessionQuery = (key) => {
  return JSON.parse(sessionStorage.getItem(key) || '{}');
};

/**
 * 千分符
 * @param {Number | String} num 
 */
const toThousands = (num) => {
  const reg = /\d{1,3}(?=(\d{3})+$)/g;
  if (!num) return 0;
  return (Math.round(num) + '').replace(reg, '$&,');
}

/**
 * 四舍五入先取整，再添加千分符
 * @param {Number | String} num 
 */

const toParsIntThousands = (num) =>{
  
}

/**
 * 检测是否是手机
 */
const isMobile = () => {
  const userAgent = navigator.userAgent
  return userAgent.indexOf('Android') > -1 
          || userAgent.indexOf('Adr') > -1
          || !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

/**
 * 保存文件
 * @param {*} url 
 * @param {*} filename 
 */
const saveFile = (url, filename) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename || +new Date()
  a.click()
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}


/**
 * canvas转image
 * @param {*} canvas 
 */
const convertCanvasToImage = (canvas) => {
  console.log(canvas);
  const image = new Image();
  const blob = typeof canvas ==='string' ? dataURLtoBlob(canvas) : dataURLtoBlob(canvas.toDataURL("image/png"));
  const src = URL.createObjectURL(blob);

  image.src = src;
  return image;
}


const getQueryString = (name) => {   
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");   
  var r = window.location.search.substr(1).match(reg);   
  if (r != null) return decodeURI(r[2]); return null;   
} 


export {
  getSessionQuery,
  toThousands,
  isMobile,
  saveFile,
  convertCanvasToImage,
  getQueryString
};


// WEBPACK FOOTER //
// src/utils.js